export default "{{render_context}} .pdc-widget-html {\r\n}";